export var isImage = function isImage(type) {
  return !!type && (type.indexOf('image/') > -1 || type.indexOf('video/') > -1 || type === 'image');
};
export var isVideo = function isVideo(fileType) {
  return !!fileType && fileType.includes('video/');
};